import { formatTechDate } from 'modules/shared/utils';
import { config } from '../../../../../config';
import { restClient } from '.';
import {
    CreateNewsletterWithProspect,
    GetNewsletterByToken,
    GetNewsletterByExternalToken,
    Newsletter,
    UpdateNewsletter,
} from '../../../models';

export const newsletterService = {
    requestAccess: async (email: string) => {
        const response = await restClient.post<void>(
            `${config.backend.rest.commonUrl}/newsletter/${encodeURIComponent(email)}/requestaccess`,
        );
        return response.data;
    },
    create: async (data: CreateNewsletterWithProspect) => {
        const localData = {
            ...data,
            eventDate: data.eventDate ? formatTechDate(data.eventDate) : undefined,
        };
        const response = await restClient.post<void>(`${config.backend.rest.commonUrl}/newsletter`, localData);
        return response.data;
    },
    getByToken: async ({ token }: GetNewsletterByToken) => {
        const response = await restClient.get<Newsletter>(
            `${config.backend.rest.commonUrl}/newsletter/token/${encodeURIComponent(token)}`,
        );
        return response.data;
    },
    updateByToken: async (token: string, data: UpdateNewsletter) => {
        const response = await restClient.put<void>(
            `${config.backend.rest.commonUrl}/newsletter/token/${encodeURIComponent(token)}`,
            data,
        );
        return response.data;
    },
    deleteByToken: async (token: string) => {
        const response = await restClient.delete<void>(
            `${config.backend.rest.commonUrl}/newsletter/token/${encodeURIComponent(token)}/`,
        );
        return response.data;
    },
    getByExternalToken: async ({ externalToken }: GetNewsletterByExternalToken) => {
        const response = await restClient.get<Newsletter>(
            `${config.backend.rest.commonUrl}/newsletter/externaltoken/${encodeURIComponent(externalToken)}`,
        );
        return response.data;
    },
    updateByExternalToken: async (externalToken: string, data: UpdateNewsletter) => {
        const response = await restClient.put<void>(
            `${config.backend.rest.commonUrl}/newsletter/externaltoken/${encodeURIComponent(externalToken)}`,
            data,
        );
        return response.data;
    },
    deleteByExternalToken: async (externalToken: string) => {
        const response = await restClient.delete<void>(
            `${config.backend.rest.commonUrl}/newsletter/externaltoken/${encodeURIComponent(externalToken)}/`,
        );
        return response.data;
    },
};
